import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import type { ReactNode } from 'react';

interface FeedItemProps {
  phrase: ReactNode;
  metadata?: ReactNode;
  action?: ReactNode;
  testId?: string;
}

const FeedItem = ({ phrase, metadata, action, testId }: FeedItemProps) => (
  <Stack direction="row" sx={{ alignItems: 'flex-start', gap: 1, pb: 2 }} test-id={testId}>
    <Box
      aria-hidden
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 16,
        height: 16,
        mt: 0.25,
      }}
    >
      <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: 'accent.light' }} />
    </Box>
    <Stack sx={{ flex: 1, minWidth: 0, gap: 0.5 }}>
      <Typography
        variant="body2"
        component="span"
        color="text.primary"
        sx={{ display: 'block', minHeight: 18, lineHeight: 1.5, overflowWrap: 'anywhere' }}
      >
        {phrase}
      </Typography>
      {metadata && (
        <Typography variant="micro1" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
          {metadata}
        </Typography>
      )}
      {action && <Box>{action}</Box>}
    </Stack>
  </Stack>
);

FeedItem.displayName = 'FeedItem';
export type { FeedItemProps };
export default FeedItem;
